import React, { Component } from "react";
import "./footer.component.css"
export class Footer extends Component {
    render() {
        return(
            <footer className="footer-wrapper">
                <div className="footer-left-container">
                    <p className="footer-label">© 2021 Accenture. All Rights Reserved.</p>
                    <a href="#" className="footer-label">Terms of Use</a>
                    <a href="#" className="footer-label">Contact Support</a>
                </div>
                <div className="footer-right-container">
                    <p className="footer-label client-label">Accenture Technology Expense Management</p>
                    <div className="footer-separator"></div>
                    <p className="footer-label">for Accenture Operations</p>
                </div>
            </footer>
        )
    }
}